import { getApiBase, getAuthHeaders } from '../config/api';
import { apiClient } from './apiClient';

export interface SensitiveTermItem {
  id: number;
  term: string;
  isRegex: boolean;
  severity: 'warn' | 'block';
  appliesTo?: 'text' | 'image' | 'both';
  createdAt: string;
  updatedAt: string;
}

export class BotModeratorService {
  private static baseUrl = getApiBase();
  private static headers() { return getAuthHeaders(); }

  static async listSensitiveTerms(): Promise<SensitiveTermItem[]> {
    const res = await apiClient.get('/moderation/sensitive-terms');
    if (!res.ok) throw new Error('Không thể tải danh sách từ nhạy cảm');
    return res.json();
  }

  static async addSensitiveTerm(body: { term: string; isRegex?: boolean; severity?: 'warn' | 'block'; appliesTo?: 'text' | 'image' | 'both' }): Promise<SensitiveTermItem> {
    const res = await apiClient.post('/moderation/sensitive-terms', body);
    if (!res.ok) throw new Error('Không thể thêm từ nhạy cảm');
    return res.json();
  }

  static async updateSensitiveTerm(id: number, body: { term?: string; isRegex?: boolean; severity?: 'warn' | 'block'; appliesTo?: 'text' | 'image' | 'both' }): Promise<SensitiveTermItem> {
    const res = await apiClient.put(`/moderation/sensitive-terms/${id}`, body);
    if (!res.ok) throw new Error('Không thể cập nhật từ nhạy cảm');
    return res.json();
  }

  static async deleteSensitiveTerm(id: number): Promise<{ message: string }> {
    const res = await apiClient.delete(`/moderation/sensitive-terms/${id}`);
    if (!res.ok) throw new Error('Không thể xóa từ nhạy cảm');
    return res.json();
  }
}


